import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon-whatsapp"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path
        d="M12.216 0c-1.541-.006-3.069.291-4.495.875S4.998 2.318 3.903 3.404s-1.964 2.376-2.56 3.797-.905 2.946-.912 4.488a11.57 11.57 0 0 0 1.704 6.048L0 24l6.528-2.064a11.83 11.83 0 0 0 5.688 1.44C18.72 23.376 24 18.144 24 11.688S18.72 0 12.216 0zm0 21.432c-1.918.003-3.796-.556-5.4-1.608L3.048 21l1.224-3.6c-1.218-1.655-1.874-3.657-1.872-5.712 0-2.603 1.034-5.1 2.875-6.941s4.338-2.875 6.941-2.875 5.1 1.034 6.941 2.875 2.875 4.338 2.875 6.941c0 5.376-4.416 9.744-9.816 9.744zm5.52-7.08a53.32 53.32 0 0 0-2.016-1.056c-.264-.096-.48-.168-.672.12a17.96 17.96 0 0 1-1.008 1.152c-.168.192-.36.192-.648.048-.288-.168-1.248-.528-2.376-1.584a8.93 8.93 0 0 1-1.584-2.112c-.168-.312 0-.48.168-.624l.456-.504c.168-.168.216-.288.312-.48.12-.192.072-.36 0-.528l-.84-2.256c-.216-.6-.48-.504-.648-.504l-.576-.048c-.192 0-.528.048-.816.336s-1.104.984-1.152 2.448.96 2.928 1.104 3.144c.144.192 1.968 3.384 4.968 4.68 3.024 1.32 3.024.912 3.576.888.576-.024 1.824-.648 2.088-1.344.288-.696.312-1.296.24-1.416s-.264-.216-.576-.36z"
        transform="scale(0.80) translate(3,3)"
      />
    </svg>
  );
}
